interface MessageModalProps {
  open: boolean;
  title: string;
  message: string;
  variant?: 'error' | 'success' | 'info';
  onClose: () => void;
  buttonLabel?: string;
}

export default function MessageModal({
  open,
  title,
  message,
  variant = 'error',
  onClose,
  buttonLabel = 'OK',
}: MessageModalProps) {
  if (!open) return null;

  const titleColor =
    variant === 'success'
      ? 'text-green-600'
      : variant === 'info'
        ? 'text-indigo-600'
        : 'text-red-600';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full text-center">
        <p className={`text-lg font-semibold mb-2 ${titleColor}`}>{title}</p>
        <p className="text-gray-600 text-sm mb-4">{message}</p>
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 cursor-pointer"
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}
